import { PaymentResolveRadioValues } from '../../utils/PaymentResolveRadioValues'
import { RpOccurrenceEditProxyFormFieldNamesEnum } from './rpOccurrenceEditProxyFormFieldNamesEnum'

export const OPTIONAL_FIELDS_REQUIRED_FOR_SUBMISSION = [
  RpOccurrenceEditProxyFormFieldNamesEnum.NextPaymentDate,
  RpOccurrenceEditProxyFormFieldNamesEnum.CustomerCard
]

export const PAYMENT_FIELDS_REQUIRED_FOR_SUBMISSION = [
  RpOccurrenceEditProxyFormFieldNamesEnum.CustomerCard
]

export function fieldsRequiredForSubmission (resolveRadioValue: string | null): RpOccurrenceEditProxyFormFieldNamesEnum[] {
  if (resolveRadioValue === PaymentResolveRadioValues.RESUME_PAYMENT) {
    return OPTIONAL_FIELDS_REQUIRED_FOR_SUBMISSION
  }
  return PAYMENT_FIELDS_REQUIRED_FOR_SUBMISSION
}
